import { css, unsafeCSS } from 'lit-element';
import {
  g300, g55, n670, n75, n200, negative400, white, n50,
} from '@aab/sc-styles-colors';
import {
  col, row, col_6 as col6,
} from '@aab/sc-styles-grid';
import {
  p_0 as p0,
  p_1 as p1,
  px_2 as px2,
  py_1 as py1,
  my_0 as my0,
  spx_2 as spx2,
  mx_0 as mx0,
} from '@aab/sc-styles-spacing';
import {
  d_none as dNone,
  d_block as dBlock,
  d_flex as dflex,
  flex_row as flexRow,
  justify_content_between as justifyContentBetween,
  shadow_dropdown as shadowDropdown,
  align_self_center as alignSelfCenter,
  align_items_center as alignItemsCenter,
  overflow_auto as overflowAuto,
  text_break as textBreak,
  position_relative as positionRelative,
  position_absolute as positionAbsolute,
  rounded_2 as rounded2,
  opacity_5 as opacity5,
} from '@aab/sc-styles-utilities';

const selectStyles = css`
${unsafeCSS(row)}
${unsafeCSS(col)}
${unsafeCSS(col6)}
${unsafeCSS(p0)}
${unsafeCSS(p1)}
${unsafeCSS(px2)}
${unsafeCSS(py1)}
${unsafeCSS(mx0)}
${unsafeCSS(my0)}
${unsafeCSS(spx2)}
${unsafeCSS(dNone)}
${unsafeCSS(dBlock)}
${unsafeCSS(dflex)}
${unsafeCSS(flexRow)}
${unsafeCSS(justifyContentBetween)}
${unsafeCSS(shadowDropdown)}
${unsafeCSS(alignSelfCenter)}
${unsafeCSS(alignItemsCenter)}
${unsafeCSS(overflowAuto)}
${unsafeCSS(textBreak)}
${unsafeCSS(positionRelative)}
${unsafeCSS(rounded2)}
${unsafeCSS(positionAbsolute)}
${unsafeCSS(opacity5)}
${unsafeCSS(textBreak)}

  .aab-dropdown__label {
    cursor: default;
  }

  .aab-dropdown {
    list-style: none;
    margin-bottom: 0;
    border: 1px solid ${unsafeCSS(n75)};
    background: ${unsafeCSS(white)};
  }

  .aab-dropdown__list {
    flex: 1;
    left: 0;
    width: 100%;
    outline: none;
    -webkit-transition: opacity 0.1s cubic-bezier(0, 0, 0.38, 0.9), max-height 0.5s cubic-bezier(0, 0, 0.38, 0.9);
    transition: opacity 0.1s cubic-bezier(0, 0, 0.38, 0.9), max-height 0.5s cubic-bezier(0, 0, 0.38, 0.9);
    max-height: 450px;
  }

   .aab-dropdown__list-container.expand {
    border-top: none;
    width: 100%;
    z-index: 4;
  }

  .aab-dropdown ul {
    list-style: none;
    width:100%;
  }

  .aab-dropdown__list ul {
    list-style: none;
  }

  .aab-dropdown__list-item {
    cursor: pointer;
    -webkit-transition: background-color .1s linear, color .1s linear;
    transition: background-color .1s linear, color .1s linear;
    list-style-position: inside;
    background-color: ${unsafeCSS(white)};
    min-height: 24px;
    font-size: 16px;
  }

  .aab-dropdown__list-item.selected {
    background-color: ${unsafeCSS(g300)};
    color: ${unsafeCSS(white)};
  }

  .aab-dropdown__list-item:hover {
    background-color: ${unsafeCSS(g55)};
    color: ${unsafeCSS(n670)}
  }

  #aab-dropdown__selected {
    cursor: pointer;
    list-style-position: inside;
  }

  #aab-dropdown__selected.invalid {
      border: 1px solid ${unsafeCSS(negative400)};
    }

   .aab-dropdown__list-item.selected {
    background-color: ${unsafeCSS(g300)};
    color: ${unsafeCSS(white)};
  }

  .disabled {
    cursor: not-allowed !important;
    color: ${unsafeCSS(n200)};
    outline: none;
  }
  .disabled:active {
    pointer-events: none;
  }
  .aab-dropdown__list-item.disabled:hover {
    background: ${unsafeCSS(white)};
    color: ${unsafeCSS(n200)};
  }
  .icon-height {
    height: 25px;
    padding-right: 10px;
  }
  .text-height {
    line-height: 24px;
  }
  .icon-font {
    font-weight:500;
  }
  #aab-dropdown__selected.disabled,
  .select-area-no-border{
    border: none !important;
  }
  .value-disabled{
    background-color: ${unsafeCSS(n50)};
  }
  .icon-disabled{
    background-color: ${unsafeCSS(n75)};
  }
  .full-width-dropdown{
    max-height: 376px !important;
    width: 100% !important;
  }
  @media (min-width: 768px) {
    .full-width-dropdown{
    width: 314px !important;
    }
  }
`;

export default selectStyles;
